export const MAX_VIDEO_SIZE_MB = 500
export const MAX_IMAGE_SIZE_MB = 20
export const MAX_IMAGE_DIMENSION = 4096

export const MAX_VIDEO_SIZE = MAX_VIDEO_SIZE_MB * 1024 * 1024
export const MAX_IMAGE_SIZE = MAX_IMAGE_SIZE_MB * 1024 * 1024

export const ACCEPTED_IMAGE_TYPES = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'] as const
export const ACCEPTED_VIDEO_TYPES = ['video/mp4'] as const

export const ACCEPTED_FILE_TYPES = [...ACCEPTED_IMAGE_TYPES, ...ACCEPTED_VIDEO_TYPES] as const
